import useSuspenseQuery from 'commons/useSuspenseQuery';
import { PRODUCT_CUSTOMER_PHOTOS_REVIEWS_MIN } from 'data-hooks/queries';
import usePDPApolloQueryVariables from '../usePDPApolloQueryVariables';

const useProductCustomerPhotosReviewsMin = () => {
  const { variables, skip } = usePDPApolloQueryVariables();

  const { data: responseData, loading, error } = useSuspenseQuery(
    PRODUCT_CUSTOMER_PHOTOS_REVIEWS_MIN,
    {
      variables,
      skip,
    }
  );

  const data = responseData?.productCustomerPhotosAndReviewsMin;

  return {
    data,
    error,
    loading: loading && !data,
  };
};

export default useProductCustomerPhotosReviewsMin;
